const moveAllUp = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M11.472 7.588 7.961 4.111 4.528 7.508 3.472 6.442 7.96 2l4.568 4.522zm0 6-3.511-3.477-3.433 3.397-1.056-1.066L7.96 8l4.568 4.522z"/></svg>',
};

export { moveAllUp as default };
